import { PUZZLE_TYPES, PUZZLE_CONFIG } from './config';
import { SeededRandom } from '../../engine/SeededRandom';

class PuzzleGenerator {
  constructor(seed = Date.now()) {
    this.rng = new SeededRandom(seed);

  }

  generateBinaryPuzzle() {

    const config = PUZZLE_CONFIG[PUZZLE_TYPES.BINARY];
    const size = 3; // Always 3x3
    
    // Generate a random solution grid of 0s and 1s
    const solution = Array(size).fill().map(() => 
      Array(size).fill().map(() => this.rng.rangeInt(0, 1))
    );

    
    // Create initial grid with all cells filled but some incorrect
    const initial = Array(size).fill().map((_, i) => 
      Array(size).fill().map((_, j) => {
        // 70% chance to start with incorrect value
        if (this.rng.random() < 0.7) {
          return solution[i][j] === 1 ? 0 : 1; // Opposite of solution
        }
        return solution[i][j]; // Correct value
      })
    );



    const puzzle = {
      type: PUZZLE_TYPES.BINARY,
      timeLimit: config.time,
      initial,
      solution,
      size
    };


    return puzzle;
  }

  generatePuzzle() {

    return this.generateBinaryPuzzle();
  }
}

export default PuzzleGenerator;